import * as types from '../constants/ActionTypes';

export function setGlobalMsg(level, message) {
	return { type: types.SET_GLOBAL_MSG, level, message };
}

export function clearGlobalMsg() {
	return { type: types.CLEAR_GLOBAL_MSG };
}



// WEBPACK FOOTER //
// ./src/assets/js/actions/global-msg.js